import "./styles.sass"

export const ToggleButton = ({isToggle, onToggle}) => {
  return (
    <section className={`toggle_container ${isToggle ? 'toggled' : ""}`} onClick={onToggle}>
      <label className="toggle_btn" />
    </section>
  )
}